/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, { useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';

import { ReactComponent as PortfolioHovered } from './img/hovered-icon.svg';
import { ReactComponent as Edit } from '../../../assets/edit-icon.svg';
import { ReactComponent as Delete } from '../../../assets/delete-black-icon.svg';
import { useTranslation } from 'react-i18next';
import { Button, Col, Row } from 'antd';

import {
  numberWithSpaces,
  numberWithSpacesInter,
} from '../../../helpers/formatInteger';

import fadeDark from './img/fade.png';
import fadeLight from './img/fade_light.png';
import glass from './img/orange-bcg-01.svg';

import './style.scss';
import ModalDeletePortfolio from '../../../components/ModalDeletePortfolio/ModalDeletePortfolio';

export const ColorDataItem = ({ text, value, isSelected }) => (
  <div className="portfolio-card-item ">
    <span
      className={`portfolio-card-item-title ${isSelected ? 'selected' : ''}`}
    >
      {text}
    </span>
    <span
      className={`portfolio-card-item-value ${value >= 0 ? 'green' : 'red'}`}
    >
      {value > 0 ? '+' : ''}
      {value ? numberWithSpacesInter(value, 2) : '-'}%
    </span>
  </div>
);

const ClientPortfolioListItem = ({
  item,
  selectedRowKeys,
  setSelectedRowKeys,
  deprecated,
  is_locked,
  theme,
}) => {
  const { t } = useTranslation('');
  const [isHovered, setIsHovered] = useState(false);
  const { account_id, name, total_value, portfolio_code } = item;
  const location = useLocation();
  const history = useHistory();
  const return_main = item.return;
  const volatility = item.vol;
  const cvar = item.cvar;

  const [modalDeleteVisible, setModalDeleteVisible] = useState(false);

  const isSelecte = useMemo(() => {
    return selectedRowKeys === item?.id;
  }, [selectedRowKeys, item]);

  const setItemSelected = () => {
    setSelectedRowKeys(item?.id);
  };

  const backgroundSelected = useMemo(() => {
    const color = item?.color ?? '#FB7B34';
    const fade = theme === 'dark-theme' ? fadeDark : fadeLight;

    return `url(${glass}), url(${fade}), ${color}`;
  }, [theme, item]);

  const hendleEdit = (id) => {
    console.log('Edit id', id);
    history.push(`${location.pathname}/${id}/holdings`);
  };

  const handleDelete = () => {
    setModalDeleteVisible(true);
  };

  return (
    <div
      onClick={setItemSelected}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: isSelecte || isHovered ? backgroundSelected : undefined,
      }}
      className={`client portfolio-card ${!isSelecte ? 'unselected' : 'selected'}`}
    >
      <div>
        <div className="portfolio-card-icons">
          {isSelecte ? (
            <div className="cell-button-wrapper">
              <Button type="text" onClick={() => hendleEdit(item.id)}>
                <Edit />
              </Button>
              <Button disabled={deprecated} type="text" onClick={() => handleDelete(item.id)}>
                <Delete />
              </Button>
            </div>
          ) : (
            <PortfolioHovered />
          )}
        </div>
        <p className="portfolio-card-name">
          {name}
          <span className="portfolio-card-code">{portfolio_code}</span>
        </p>
        {deprecated ? (
          <span className="portfolio-card-deprecated">{t('IN_EXECUTION')}</span>
        ) : is_locked ? (
          <span className="portfolio-card-deprecated">{t('LOCKED')}</span>
        ) : null}
      </div>
      <div>
        <p className="portfolio-card-value">{`${numberWithSpaces(Math.round(total_value))} kr`}</p>
        <Row justify={'center'} className="portfolio-card-text">
          <Col className="">
            <ColorDataItem
              isSelected={isSelecte}
              text={t('RETURN')}
              value={return_main}
            />
          </Col>
          <Col className="">
            <ColorDataItem
              isSelected={isSelecte}
              text={t('VOLATILITY')}
              value={volatility}
            />
          </Col>
          <Col className="">
            <ColorDataItem
              isSelected={isSelecte}
              text={t('CVaR')}
              value={cvar}
            />
          </Col>
        </Row>
      </div>
      <ModalDeletePortfolio
        modalDeleteVisible={modalDeleteVisible}
        setModalDeleteVisible={setModalDeleteVisible}
        portfolioId={item.id}
        userId={account_id}
        name={name}
        is_composite={false}
      />
    </div>
  );
};

export default ClientPortfolioListItem;

ClientPortfolioListItem.propTypes = {
  item: PropTypes.object,
  selectedRowKeys: PropTypes.number,
  setSelectedRowKeys: PropTypes.func,
  deprecated: PropTypes.bool,
  is_locked: PropTypes.bool,
  theme: PropTypes.string,
};

ColorDataItem.propTypes = {
  text: PropTypes.string,
  value: PropTypes.number,
  isSelected: PropTypes.bool,
};
